import { retirementsMiddleware } from './retirement-middleware';

export const retirementMiddleware = [retirementsMiddleware];
